import { connect } from 'react-redux';
import {
  getTravelTimesByPostcode,
  getTeamAvailability,
  getPostcodeDistance,
} from '../../../actions/areas/dailyPlanning';
import { deleteAssignment, rescheduleAssignment, getTreatmentInstanceByAssignmentId } from '../../../actions/entities';
import TimelineAssignment from '../../../components/DailyPlanning/TimelineAssignment/TimelineAssignment';
import { selectAssignmentById } from '../../../reducers/entities/postings/selectors';
import {
  getPostingsUpdateDataAfterReschedule,
  getPostingsUpdateDataAfterUnAssign,
  getCopiesPostings,
} from '../../../actions/entities/postings';
import {
  getTreatmentInstancesCopies,
  removeTreatmentInstanceCopies,
} from '../../../actions/entities/treatmentInstances';

const mapStateToProps = (state, ownProps) => {
  const {
    global: { auth },
    areas: { dailyPlanning },
  } = state;
  return {
    assignment: selectAssignmentById(state, ownProps),
    travelTime: state.entities.postings.general.travelTimes[ownProps.postcode],
    jwtToken: auth.jwtToken,
    teamId: dailyPlanning.filters.selectedTeam,
    selectedDate: dailyPlanning.selectedDate,
  };
};

const mapDispatchToProps = dispatch => ({
  rescheduleAssignment: (assignGuid, oldPostingId, postingId, newAssignmentTime) =>
    dispatch(rescheduleAssignment(assignGuid, oldPostingId, postingId, newAssignmentTime)),
  removeAssignment: (id, assignGuid, postingId) => dispatch(deleteAssignment(id, assignGuid, postingId)),
  getTravelTimesByPostcode: postcode => dispatch(getTravelTimesByPostcode(postcode)),
  getCopiesPostings: newAssignmentId => dispatch(getCopiesPostings(newAssignmentId)),
  getPostcodeDistance: postcode => dispatch(getPostcodeDistance(postcode)),

  refreshSchedulerAfterReschedule: async (
    assignGuid,
    newAssignmentId,
    postingId,
    newPostingId,
    date,
    treatmentInstanceId,
    teamId,
    isPatientAssignment,
    doesHaveCopies,
    jwtToken,
  ) => {
    await dispatch(getPostingsUpdateDataAfterReschedule(assignGuid, newAssignmentId, postingId, newPostingId, date));
    if (isPatientAssignment && doesHaveCopies) {
      await dispatch(removeTreatmentInstanceCopies(treatmentInstanceId));
      await dispatch(getTreatmentInstancesCopies(newAssignmentId, teamId, jwtToken));
    }
    await dispatch(getTeamAvailability(teamId, date, jwtToken, 0));
  },
  refreshSchedulerAfterUnassign: async (
    assignGuid,
    newAssignmentId,
    postingId,
    date,
    duration,
    teamId,
    treatmentInstanceId,
    jwtToken,
  ) => {
    await dispatch(getPostingsUpdateDataAfterUnAssign(assignGuid, newAssignmentId, postingId, date, teamId));
    await dispatch(removeTreatmentInstanceCopies(treatmentInstanceId, jwtToken));
    await dispatch(getTreatmentInstanceByAssignmentId(newAssignmentId, teamId));
    await dispatch(getTeamAvailability(teamId, date, jwtToken, -duration));
  },
});

const TimelineAssignmentContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TimelineAssignment);

export default TimelineAssignmentContainer;
